module.exports = __webpack_public_path__ + "img/179.af7f8b90.jpg";